import React from "react";
import {Badge} from 'reactstrap';

const RCIDStatus = ({ status}) => {
    if (status === 'active') {
        return <Badge color="success" className="mr-1 mb-1">
            Active
        </Badge>
    }else if (status === 'inactive') {
        return <Badge color="warning" className="mr-1 mb-1">
            Not active
        </Badge>
    }else if (status === 'testing') {
        return <Badge color="primary" className="mr-1 mb-1">
            Testing
        </Badge>
    }
};

export default RCIDStatus;
